import api from '@/services/api'

const state = {

}

// getters
const getters = {}

// actions
const actions = {
  import ({ commit }, id) {
    return new Promise( (resolve) => {
      api().get('/datasheets/import/' + id).then( (response) => {
        resolve(response.data)
      });
    })
  },
  info ({ commit }, id) {
    return new Promise( (resolve) => {
      api().get('/datasheets/checksum/' + id).then( (response) => {
        resolve(response.data.data)
      });
    })
  },
  list ({ commit }) {
    return new Promise( (resolve) => {
      api().get('/datasheets').then( (response) => {
        resolve(response.data.data)
      });
    })
  },
  fillData ({ commit }, params) {
    return new Promise( (resolve) => {
      api().post('/data/fill', params).then( (response) => {
        resolve(response.data.data)
      });
    })
  },
  applySlots ({ commit }, params) {
    return new Promise( (resolve) => {
      api().post('/data/apply-slots', params).then( (response) => {
        resolve(response.data.data)
      });
    })
  },
  status() {
    return new Promise( (resolve) => {
      api().post('/data/status').then( (response) => {
        resolve(response.data.data)
      });
    })
  }
}

// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/datasheets.js